<template>
    <v-dialog
        v-model="showDialog"
        width="600"
    >
        <v-card>
            <v-form
                ref="form"
                v-model="valid"
                lazy-validation
                @submit.prevent="submitForm"
            >
                <v-card-title
                    class="teal darken-1 white--text"
                >
                    Edit Account: {{ data['PROVIDER NAME'] }}
                </v-card-title>
                <v-card-text style="padding: 20px;">
                    <v-text-field
                        v-model.trim="dataToUpdate.USERNAME"
                        color="teal darken-1"
                        dense
                        outlined
                        label="Username"
                        :rules="rules.withLetters"
                    />
                    <v-text-field
                        v-model.trim="dataToUpdate.PIC_NAME"
                        color="teal darken-1"
                        dense
                        outlined
                        label="PIC Name"
                        :rules="rules.withLetters"
                    />
                    <v-text-field
                        v-model.trim="dataToUpdate.PIC_CPNO"
                        color="teal darken-1"
                        dense
                        outlined
                        label="PIC CP Number"
                        :rules="rules.withNumbers"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        outlined
                        color="teal darken-1"
                        style="text-transform: none; width: 105px;"
                        @click="$emit('closeDialog')"
                    >
                        CANCEL
                    </v-btn>
                    <v-btn
                        color="teal darken-3 white--text"
                        style="text-transform: none; width: 105px; font-weight: 600"
                        type="submit"
                    >
                        SUBMIT
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    props: ['show', 'data'],
    data: ()=>({
        valid: false,
        reason: null,
        dataToUpdate: {
            ID: null,
            USERNAME: null,
            PIC_NAME: null,
            PIC_CPNO: null
        },
        rules: {
            withLetters: [
                v => !!v || 'This field is required',
                v => v && /[a-zA-Z]/.test(v) || 'This field is required'
            ],
            withNumbers: [
                v => !!v || 'This field is required',
                v => /\d/.test(v) || 'This field is required'
            ]
        }
    }),
    computed: {
        showDialog: {
            ...mapGetters(['editProviderAccountData']),
            get() {
                this.initData()
                return this.show
            },
            set() {
                this.$emit('closeDialog')
            }
        }
    },
    methods: {
        ...mapActions(['editProviderAccount']),
        initData() {
            this.dataToUpdate = {
                ID: this.data.ID,
                USERNAME: this.data.USERNAME,
                PIC_NAME: this.data['PIC NAME'],
                PIC_CPNO: this.data['CONTACT NO.']
            }
        },
        resetReason() {
            if (this.$refs && this.$refs.reason) {
                this.$refs.reason.reset()
            }
        },
        submitForm() {
            if (this.$refs.form && this.$refs.form.validate()) {
                this.editProviderAccount({
                    ID: this.dataToUpdate.ID,
                    USERNAME: this.dataToUpdate.USERNAME,
                    PIC_NAME: this.dataToUpdate.PIC_NAME,
                    PIC_CPNO: this.dataToUpdate.PIC_CPNO
                })
            }
        }
    }
}
</script>
